import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CheckIcon from "@material-ui/icons/Check";
import WhatsappButton from "../../../../components/whatsappButton/WhatsappButton";

import {
  HeaderAccordion,
  IconButtonStyled,
  TableContent,
} from "../styles/Cliente";
import TableDefault from "../../../../components/grid/TableDefault";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import useClienteController from "../controllers/ClienteController";
import ModalClienteContato from "./ModalClienteContato";
import Chip from "../../../../components/basics/Chip";
import { DeleteOutlined } from "@material-ui/icons";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "principal",
    label: "Principal",
    format: (item) => item.principal.toString() === "1" && <CheckIcon />,
  },
  {
    id: "nomecontato",
    label: "Nome",
  },
  {
    id: "email",
    label: "E-mail",
  },

  {
    id: "whatsapp_ativo",
    label: "Celular",
    format: (item) => {
      return (
        <>
          {item.whatsapp_ativo === 1 && (
            <div>
              <WhatsappButton celular={item?.celular} />
            </div>
          )}
        </>
      );
    },
  },
  {
    id: "depto",
    label: "Departamento",
  },
  {
    id: "cep",
    label: "CEP",
  },
  {
    id: "endereco",
    label: "Endereço",
  },
  {
    id: "numero",
    label: "Número",
    align: "center",
  },
];

export default function AccordionClienteContato() {
  const {
    contacts,
    setContacts,

    expanded,
    errors,
  } = useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useClienteController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    (async () => {
      const newList = [];
      contacts.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            celular: MaskService.toMask("cel-phone", item.celular || ""),
            cep: MaskService.toMask("cep", item.cep || ""),
            acoes: (
              <SpeedDialErp
                actions={[
                  {
                    icon: <EditOutlinedIcon />,
                    name: "Editar",
                    action: () =>
                      handleEditItemTable(setOpen, setRowEdit, item, index),
                  },
                  {
                    icon: <DeleteOutlined />,
                    name: "Excluir",
                    action: () =>
                      handleRemoveItemTable(
                        setContacts,
                        setDataTable,
                        contacts,
                        index
                      ),
                  },
                ]}
              />
            ),
          })
      );

      setDataTable(newList);
    })();
  }, [contacts, setContacts, handleEditItemTable, handleRemoveItemTable]);

  return (
    <>
      {open && (
        <ModalClienteContato
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion expanded={expanded.contacts || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("contacts")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("contacts")}
                >
                  <Chip
                    label="CONTATOS"
                    bgcolor={
                      !expanded.contacts &&
                      errors.accordions &&
                      errors.accordions.includes("contacts")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.contacts &&
                      errors.accordions &&
                      errors.accordions.includes("contacts")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>

                <Grid item flex={1}>
                  <Tooltip title="Adicionar Contato">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
